import React, { useEffect, useState } from "react";
import { Accordion, Card } from "react-bootstrap";
import { Col } from "react-bootstrap";
import { Row } from "react-bootstrap";
import { MdKeyboardArrowRight } from "react-icons/md";

import { URL_CONFIG } from "app/_constants/Config/URL_CONFIG";
import { getIncidentReportById } from "app/_services/ehs/ehsIncidentServices";
import IncidentDetailsInfo from "./Investigator/IncidentDetailsInfo";
import MultiLineTextArea from "./MultiLineTextArea";
import IncidentEvidences from "./IncidentEvidences";
import IncidentComments from "./IncidentComments";
import IncidentTimeline from "./IncidentTimeline";
import {
  initialForm,
  commentTypes,
  evidenceCategories,
  incidentCauses,
  incidentFireCauses,
  reasonsToAvoid,
  severities,
  STAFFEMPLOYER,
  FORM_LABEL_OFFICER,
} from "./CONSTANTS";
import {
  contractorDropdownLabel,
  employeeDropdownLabel,
  formatDDMMYYYYbyYYYYMMDD,
} from "app/_helpers/helper";
import Capas from "../Capas";
import { getContractor } from "app/_services/Contractor/ContractorService";

const ViewIncidentInvestigation = ({
  match: {
    params: { id: incidentDetailsId = null },
  },
  history,
}) => {
  const [tab, setTab] = useState(1);
  const [form, setForm] = useState({ ...initialForm, id: incidentDetailsId });

  const [compliances, setCompliances] = useState([]);
  const [trainings, setTrainings] = useState([]);
  const [witnessStatements, setWitnessStatements] = useState([]);
  const [capas, setCapas] = useState([]);
  const [evidences, setEvidences] = useState([]);
  const [mitigationMeasures, setMitigationMeasures] = useState([]);
  const [rootCauseDescriptions, setRootCauseDescriptions] = useState([]);
  const [solutions, setSolutions] = useState([]);
  const [comments, setComments] = useState([]);
  const [contractors, setContractors] = useState([]);

  useEffect(() => {
    getContractor().then((response) => {
      if (!response?.data) return;

      setContractors(response.data);
    });
  }, []);

  useEffect(() => {
    getIncidentReportById(incidentDetailsId).then((response) => {
      if (!response?.data) return;

      setForm((prev) => {
        if (response.data.site?.siteType === 3) {
          prev.roName = response?.data?.site?.parentSite?.name;
          prev.roSiteId = response?.data?.site?.parentSite?.siteId;
        } else if (response?.data?.site?.siteType === 2) {
          prev.roName = response?.data?.site?.name;
          prev.roSiteId = response?.data?.site?.siteId;
        } else {
          prev.roName = "";
          prev.roSiteId = "";
        }

        return {
          ...prev,
          ...response.data,
          locationSiteId: response.data.site?.siteId,
        };
      });

      //setForm(response.data);
      setCompliances(response.data.compliances || []);
      setTrainings(response.data.trainings || []);
      setWitnessStatements(response.data.witnessStatements || []);
      setCapas(response.data.capas || []);
      setEvidences(
        response.data?.evidences?.filter((data) => data.category === "Investigation") ||
          []
      );
      setMitigationMeasures(response.data.mitigationMeasures || []);
      setRootCauseDescriptions(response.data.rootCauseDescriptions || []);
      setSolutions(response.data.solutions || []);
      setComments(
        response?.data?.comments?.filter(
          (data) => data.type === commentTypes.investigation
        ) || []
      );
    });
  }, [incidentDetailsId]);

  return (
    <>
      <div className="healthSafetyEnvironmentWrapper">
        <div className="healthSafetyEnvironmentWrapper incidentMenu">
          <div className="hseMenuLinks card pointer" style={{ minHeight: 75 }}>
            <a className={`${tab === 1 ? "active" : ""}`} href onClick={() => setTab(1)}>
              Timeline
            </a>
            <a className={`${tab === 2 ? "active" : ""}`} href onClick={() => setTab(2)}>
              Investigator Inputs
            </a>
            <a className={`${tab === 3 ? "active" : ""}`} href onClick={() => setTab(3)}>
              Insaurance Details
            </a>
            <a className={`${tab === 4 ? "active" : ""}`} href onClick={() => setTab(4)}>
              Incident Investigation
            </a>
            <a className={`${tab === 5 ? "active" : ""}`} href onClick={() => setTab(5)}>
              Regulatory Compliance
            </a>
            <a className={`${tab === 6 ? "active" : ""}`} href onClick={() => setTab(6)}>
              Environmental Assessment
            </a>
            <a className={`${tab === 7 ? "active" : ""}`} href onClick={() => setTab(7)}>
              Training Requirements
            </a>
            <a className={`${tab === 8 ? "active" : ""}`} href onClick={() => setTab(8)}>
              Mitigtion Measures
            </a>
            <a className={`${tab === 9 ? "active" : ""}`} href onClick={() => setTab(9)}>
              Witness Statements
            </a>
            <a
              className={`${tab === 10 ? "active" : ""}`}
              href
              onClick={() => setTab(10)}
            >
              Root Cause Analysis
            </a>
            <a
              className={`${tab === 11 ? "active" : ""}`}
              href
              onClick={() => setTab(11)}
            >
              Solution
            </a>
            <a
              className={`${tab === 12 ? "active" : ""}`}
              href
              onClick={() => setTab(12)}
            >
              CAPA
            </a>
            <a
              className={`${tab === 13 ? "active" : ""}`}
              href
              onClick={() => setTab(13)}
            >
              Investigaton Evidence
            </a>
          </div>
        </div>
      </div>
      <Row>
        {tab === 1 && (
          <Col lg={9}>
            <IncidentTimeline
              reportDate={form.reportDate}
              reporter={form.reporter}
              investigationCompletionDate={form.investigationCompletionDate}
              reviewCompletionDate={form.reviewCompletionDate}
              investigationDetails={form?.investigationDetails}
              reviewer={form.reviewer}
              closer={form.closer}
              personalDetails={form.personalDetails}
              vehicleDetails={form.vehicleDetails}
              assetDetails={form.assetDetails}
              spills={form.spills}
              evidences={evidences}
              investigationCompleted={form.investigationCompleted}
              reviewCompleted={form.reviewCompleted}
              closureCompleted={form.closureCompleted}
              isAssetIncident={form.isAssetIncident}
              isPersonalInjury={form.isPersonalInjury}
              isSpillsIncident={form.isSpillsIncident}
              isVehicleIncident={form.isVehicleIncident}
              closureCompletionDate={form.closureCompletionDate}
              incidentStatus={form.incidentStatus}
              insuranceApplicable={form.insuranceApplicable}
              complianceRequired={form.complianceRequired}
              trainingRequired={form.trainingRequired}
              witnessStatementRequired={form.witnessStatementRequired}
              rootCauseAnalysisRequired={form.rootCauseAnalysisRequired}
              solutionRequired={form.solutionRequired}
              capaRequired={form.capaRequired}
              reportEvidencesRequired={form.reportEvidencesRequired}
              evidencesRequired={form.evidencesRequired}
              reviewEvidencesRequired={form.reviewEvidencesRequired}
              incidentId={form.incidentId}
              incidentDate={form.incidentDate}
              type={form.type}
              severity={form.severity}
              severityPostReview={form.severityPostReview}
              workArea={form.workArea}
              area={form.area}
              site={form.site}
              department={form.department}
              isCapaPresent={form?.capas?.length}
              targetCompletionDate={form.targetCompletionDate}
              capaCompletionDate={form?.capaCompletionDate}
              capaCompletedByData={form?.capaCompletedByData}
              finalReviewedByDate={form?.finalReviewedByDate}
              finalReviewedByData={form?.finalReviewedByData}
              reviewedByMMDate={form?.reviewedByMMDate}
              reviewedByMMData={form?.reviewedByMMData}
              reviewedDate={form?.reviewedDate}
              staffData={form?.staffData}
              staffType={form?.staffType}
              otherStaffName={form?.otherStaffName}
              capasList={form?.capas}
              reportAtLabel={FORM_LABEL_OFFICER[form?.reportAtLabel]}
              form={form}
            />
          </Col>
        )}
        {tab === 2 && (
          <>
            <Col lg={6} className="pt-3">
              <IncidentComments
                comments={comments}
                setComments={setComments}
                type={commentTypes.investigation}
                viewOnly
              />
            </Col>
            <Col lg={3}>
              <div
                className="card EHS_module_create_form p-3 pb-0 mt-4"
                style={{ minHeight: 495 }}
              >
                <div className="simple-card-title">
                  <h3 className="text-capitalize mb-1">Investigation</h3>
                </div>
                <Row>
                  <Col className="my-2" lg={12}>
                    <div className="form-group mb-3">
                      <label>Investigated By</label>
                      <span>
                        {form.investigator
                          ? `${form.investigator.firstName} ${form.investigator.lastName}`
                          : ""}
                      </span>
                    </div>
                  </Col>
                  <Col className="my-2" lg={12}>
                    <div className="form-group mb-3">
                      <label>Investigation Completion Date</label>
                      <p>{formatDDMMYYYYbyYYYYMMDD(form.investigationCompletionDate)}</p>
                    </div>
                  </Col>
                  <Col className="my-2" lg={12}>
                    <div className="form-group mb-2">
                      <label>Severity (Reported)</label>
                      <p>{severities[form.severity]}</p>
                    </div>
                  </Col>
                  <Col className="my-2" lg={12}>
                    <div className="form-group mb-2">
                      <label>Investigation Completion Summary</label>
                      <p>{form.investigationCompletionSummary}</p>
                    </div>
                  </Col>
                  <Col className="my-2" lg={12}>
                    <div className="form-group mb-2">
                      <label>Investigation Completed</label>
                      <p>{form.investigationCompleted ? "Yes" : "No"}</p>
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </>
        )}
        {tab === 3 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Insurance Claim Information</h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                {form.insuranceApplicable ? (
                  <Row>
                    <Col lg={4}>
                      <div className="form-group">
                        <label>Direct Loss to Equipment/Machinery</label>
                        <p>{form.directIncidentLossToEquipment ? "Yes" : "No"}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group">
                        <label>Insurance Claim Raised</label>
                        <p>{form.insuranceClaimRaised ? "Yes" : "No"}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group">
                        <label>Direct Loss due to the incident (INR)</label>
                        <p>{form.directIncidentLoss}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group">
                        <label>Insurance Claim Amount (INR)</label>
                        <p>{form.insuranceClaimAmount}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group">
                        <label>Insurance Approved Amount (INR)</label>
                        <p>{form.insuranceApprovedAmount}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group">
                        <label>Amount Not Approved (INR)</label>
                        <p>{form.insuranceUnapprovedAmount}</p>
                      </div>
                    </Col>
                    <Col lg={4}>
                      <div className="form-group">
                        <label>Document (If any)</label>
                        <div className="uploadedFilesListInner">
                          {form.insuranceFile && (
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={URL_CONFIG.IMG_URL + form.insuranceFile.document_name}
                            >
                              Open "{form.insuranceFile.real_document_name}"
                            </a>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  <div className="text-danger">Not Applicable</div>
                )}
              </div>
            </div>
          </Col>
        )}
        {tab === 4 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Incident Investigation: </h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                <Row>
                  <Col lg={12}>
                    <div className="form-group ">
                      <h5 className="w-800">Cause of the Incident: </h5>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col lg={12} className="pb-2 mb-1 pt-1">
                    <p>
                      {form.cause
                        .map((key, i) =>
                          i === 0 ? `Other: ${key}` : incidentCauses[key]
                        )
                        .filter((data) => (data ? data.toLowerCase() !== "other" : false))
                        .join(", ")}
                    </p>
                  </Col>
                </Row>
                <div className="secDivider"></div>
                <Row>
                  <Col lg={12}>
                    <div className="form-group">
                      <h5 className="w-800">Cause of Ignition leading to fire: </h5>
                    </div>
                  </Col>
                  <Col lg={12} className="pb-2 mb-1 pt-1">
                    <label className="checkbox checkbox-primary">
                      <p>
                        {form.fireCause
                          .map((key, i) =>
                            i === 0 ? `Other: ${key}` : incidentFireCauses[key]
                          )
                          .filter((data) =>
                            data ? data.toLowerCase() !== "other" : false
                          )
                          .join(", ")}
                      </p>
                    </label>
                  </Col>
                </Row>
                <div className="secDivider"></div>
                <Row>
                  <Col lg={6}>
                    <div className="form-group ">
                      <h5 className="w-800">Was the Incident Avoidable?</h5>
                    </div>
                  </Col>
                  <Col lg={2}>
                    <div className="form-group ">
                      <h5 className="w-800">{form.avoidable}</h5>
                    </div>
                  </Col>
                </Row>
                <div className="secDivider"></div>
                {form.avoidable === "Yes" && (
                  <Row>
                    <Col lg={12}>
                      <div className="form-group ">
                        <h5 className="w-800">
                          The incident could have been avoided by the use of / or by:{" "}
                        </h5>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <div className="form-group ">
                        <h6 className="w-800">
                          {form.couldAvoidBy
                            .map((key, i) =>
                              i === 0 ? `Other: ${key}` : reasonsToAvoid[key]
                            )
                            .filter((data) =>
                              data ? data.toLowerCase() !== "other" : false
                            )
                            .join(", ")}
                        </h6>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            </div>
          </Col>
        )}
        {tab === 5 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Regulatory Compliance</h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                {compliances.length > 0 ? (
                  <div className="w-100">
                    <div className="table-responsive">
                      <table id="user_table" className="table table-bordered mb-3">
                        <thead>
                          <tr>
                            <th scope="col">S.No.</th>
                            <th scope="col">OISD / OSHA Standard</th>
                            <th scope="col">Observation</th>
                            <th scope="col">Remarks</th>
                          </tr>
                        </thead>
                        <tbody>
                          {compliances.length > 0 ? (
                            compliances.map((x, index) => {
                              return (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>{x.name}</td>
                                  <td>{x.observation}</td>
                                  <td>{x.remarks}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="10" align="center">
                                <div className="alert alert-danger d-inline-block m-0">
                                  <strong>Empty</strong>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="text-danger">Not Applicable</div>
                )}
              </div>
            </div>
          </Col>
        )}
        {tab === 6 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Environmental Assessment</h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                {form.environmentalAssessment ? (
                  <Row>
                    <Col lg={12}>
                      <p>{form.environmentalAssessment || "(NA)"}</p>
                    </Col>
                  </Row>
                ) : (
                  <div className="text-danger">Not Applicable</div>
                )}
              </div>
            </div>
          </Col>
        )}
        {tab === 7 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Training Requirement</h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                {trainings.length > 0 ? (
                  <div className="w-100">
                    <div className="table-responsive">
                      <table id="user_table" className="table table-bordered mb-3">
                        <thead>
                          <tr>
                            <th scope="col">S.No.</th>
                            <th scope="col">Training Category</th>
                            <th scope="col">Training Name</th>
                            <th scope="col">Training Need</th>
                          </tr>
                        </thead>
                        <tbody>
                          {trainings.length > 0 ? (
                            trainings.map((x, index) => {
                              return (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>{x.categoryId}</td>
                                  <td>{x.name}</td>

                                  <td>{x.need}</td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="10" align="center">
                                <div className="alert alert-danger d-inline-block m-0">
                                  <strong>Empty</strong>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="text-danger">Not Applicable</div>
                )}
              </div>
            </div>
          </Col>
        )}
        {tab === 8 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Mitigation Measures</h3>
              </div>
              <MultiLineTextArea
                title="Measurement"
                dataArray={mitigationMeasures}
                viewOnly
              />
            </div>
          </Col>
        )}
        {tab === 9 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Witness Statements</h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                {witnessStatements.length > 0 ? (
                  <div className="w-100">
                    <div className="table-responsive">
                      <table id="user_table" className="table table-bordered mb-3">
                        <thead>
                          <tr>
                            <th scope="col">S.No.</th>
                            <th scope="col">Witness Name</th>
                            <th scope="col">Date of Statement</th>
                            <th scope="col">Brief Description</th>
                            <th scope="col">Statement Evidence</th>
                          </tr>
                        </thead>
                        <tbody>
                          {witnessStatements.length > 0 ? (
                            witnessStatements.map((x, index) => {
                              return (
                                <tr key={index}>
                                  <th>{index + 1}</th>
                                  <td>{x.name}</td>
                                  <td>{formatDDMMYYYYbyYYYYMMDD(x.date)}</td>
                                  <td>{x.description}</td>
                                  <td>
                                    <div className="uploadedFilesListInner">
                                      {x.file && (
                                        <a
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          href={URL_CONFIG.IMG_URL + x.file.document_name}
                                        >
                                          Open "{x.file.real_document_name}"
                                        </a>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr>
                              <td colSpan="10" align="center">
                                <div className="alert alert-danger d-inline-block m-0">
                                  <strong>Empty</strong>
                                </div>
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="text-danger">Not Applicable</div>
                )}
              </div>
            </div>
          </Col>
        )}
        {tab === 10 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Root Cause Analysis</h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                {form.rootCauseAnalysisRequired ? (
                  <>
                    <Row>
                      <Col lg={4}>
                        <div className="form-group">
                          <label>Key Root Cause</label>
                          <p>{form.rootCause}</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <MultiLineTextArea
                          title="Cause Description"
                          dataArray={rootCauseDescriptions}
                          viewOnly
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <div className="text-danger">Not Applicable</div>
                )}
              </div>
            </div>
          </Col>
        )}
        {tab === 11 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Solution</h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                {solutions.length > 0 ? (
                  <>
                    <Row>
                      <Col lg={4}>
                        <div className="form-group">
                          <label>Solution</label>
                          <p>{form.solutionType || "(NA)"}</p>
                        </div>
                      </Col>
                    </Row>
                    <Row>
                      <Col lg={12}>
                        <MultiLineTextArea
                          title="Solution Description"
                          dataArray={solutions}
                          viewOnly
                        />
                      </Col>
                    </Row>
                  </>
                ) : (
                  <div className="text-danger">Not Applicable</div>
                )}
              </div>
            </div>
          </Col>
        )}
        {tab === 12 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Add CAPA</h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                {capas.length ? (
                  <div className="w-100">
                    <Capas capas={capas} viewOnly />
                  </div>
                ) : (
                  <div className="text-danger">Not Applicable</div>
                )}
              </div>
            </div>
          </Col>
        )}
        {tab === 13 && (
          <Col lg={9}>
            <div className="card p-3 pb-0 mt-4 EHS_module_create_form">
              <div className="simple-card-title">
                <h3 className="text-capitalize mb-0">Investigation Evidence</h3>
              </div>
              <div className="ehsFormWrapper pb-2">
                {evidences.length ? (
                  <div className="w-100">
                    <IncidentEvidences dataArray={evidences} viewOnly />
                  </div>
                ) : (
                  <div className="text-danger">Not Applicable</div>
                )}
              </div>
            </div>
          </Col>
        )}
        <Col lg={3}>
          <div className="mt-4">
            <h5>You are viewing as an Investigator.</h5>
            <Accordion>
              <div className="mb-3">
                <Accordion.Toggle
                  as={Card.Header}
                  eventKey="10"
                  className="rightIncidentCard p-0"
                >
                  <div className="rightInfoTitle">
                    Reporter
                    <MdKeyboardArrowRight />
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="10">
                  <Card.Body className="p-0">
                    <IncidentDetailsInfo
                      country={form.country}
                      state={form.state}
                      longDurationFire={form.longDurationFire}
                      lostManhoursEmployees={form.lostManhoursEmployees}
                      lostManhoursContractors={form.lostManhoursContractors}
                      lostManhoursOthers={form.lostManhoursOthers}
                      department={form.department}
                      description={form.description}
                      equipmentFailure={form.equipmentFailure}
                      fallOfObject={form.fallOfObject}
                      inundation={form.inundation}
                      explosion={form.explosion}
                      facilityOutage={form.facilityOutage}
                      facilityShutdown={form.facilityShutdown}
                      facilityStatus={form.facilityStatus}
                      fatalityEmployees={form.fatalityEmployees}
                      fatalityContractors={form.fatalityContractors}
                      fatalityOthers={form.fatalityOthers}
                      fireInvolved={form.fireInvolved}
                      functionData={form.functionData}
                      incidentDate={form.incidentDate}
                      incidentId={form.incidentId}
                      incidentStatus={form.incidentStatus}
                      indirectLosses={form.indirectLosses}
                      injuredEmployees={form.injuredEmployees}
                      injuredContractors={form.injuredContractors}
                      injuredOthers={form.injuredOthers}
                      measuresOrActions={form.measuresOrActions}
                      peopleCount={form.peopleCount}
                      permanentDisability={form.permanentDisability}
                      reportDate={form.reportDate}
                      severity={form.severity}
                      site={form.site}
                      reportedBy={form.reporter}
                      similarIncidentHappened={form.similarIncidentHappened}
                      summary={form.summary}
                      workArea={form.workArea}
                      type={form.type}
                      personalDetails={form.personalDetails}
                      assetDetails={form.assetDetails}
                      vehicleDetails={form.vehicleDetails}
                      spills={form.spills}
                      evidences={form.evidences?.filter(
                        (data) => data.category === evidenceCategories.report
                      )}
                      insuranceApplicable={form.insuranceApplicable}
                      complianceRequired={form.complianceRequired}
                      trainingRequired={form.trainingRequired}
                      witnessStatementRequired={form.witnessStatementRequired}
                      rootCauseAnalysisRequired={form.rootCauseAnalysisRequired}
                      solutionRequired={form.solutionRequired}
                      capaRequired={form.capaRequired}
                      reportEvidencesRequired={form.reportEvidencesRequired}
                      evidencesRequired={form.evidencesRequired}
                      reviewEvidencesRequired={form.reviewEvidencesRequired}
                      regionalOffice={form.site ? form.site.parentSite : ""}
                      staffType={form.staffType}
                      staffEmployer={
                        form?.staffType === "contractor"
                          ? form?.StaffNameObject?.contractors?.contractorLegalEntity
                          : STAFFEMPLOYER.find((d) => d.id === form?.staffEmployer)
                              ?.contactPerson
                      }
                      staffName={
                        form?.staffType === "employee"
                          ? `${employeeDropdownLabel(form?.staffData)}`
                          : form?.staffType === "contractor"
                          ? `${contractorDropdownLabel(form?.staffData)}`
                          : form?.otherStaffName
                      }
                      area={form.area}
                      subArea={form.subArea}
                      subAreaId={form.subAreaId}
                      otherSubArea={form.otherSubArea}
                      shift={form.shift}
                      activity={form.activity}
                      subActivity={form.subActivity}
                      capasDetails={form.capas}
                      locationSiteId={form?.locationSiteId}
                      roSiteId={form?.roSiteId}
                      contractors={contractors}
                      alcoholViolator={form.alcoholViolator}
                      ppeViolator={form.ppeViolator}
                      unfitBuyerTruck={form.unfitBuyerTruck}
                      unfitHEMM={form.unfitHEMM}
                    />
                  </Card.Body>
                </Accordion.Collapse>
              </div>
            </Accordion>
          </div>
        </Col>
      </Row>
      <div className="mt-4 text-center filterFormDivider">
        <span className="btn btn-secondary mx-2" onClick={() => history.goBack()}>
          Go Back
        </span>
      </div>
    </>
  );
};

export default ViewIncidentInvestigation;
